const domain = () => {
  let host: string = (typeof window !== 'undefined' ? window.location.hostname : '').toLowerCase();
  return host.split('.').slice(-2).join('.');
};

let amaModulesCache: any = null;

const noAdsUrls = ['www.femina.se/skonhet/framtidenshudvard'];
const isNoAdsUrl = (): boolean =>
  typeof window !== 'undefined' &&
  noAdsUrls.some((url) => (window.location.hostname + window.location.pathname).indexOf(url) === 0);


export default function getModules() {
  if (amaModulesCache) {
    return amaModulesCache;
  }

  amaModulesCache = {
    useStats: true,
    useLimitedAds: true,
    useGLazyLoad: ['responsive_1', 'top_ad'],
    useFirstWaveBatching: false,
    useSingleRequest: false,
    usePrebidVideo: true,
    useLoadDmByAdsLib: true,
    adTags:{},
    useContentUpdatedEvent: true,
    useSecondArticle: true,
    useHideAds: isNoAdsUrl(),
  }; 

  return amaModulesCache;
}
